// extracted by mini-css-extract-plugin
module.exports = {"wrap":"GTav","imageLink":"GTol","imgWrap":"GTabj","image":"GTob","textBox":"GTabh","labels":"GTabl","title":"GTal","statistic":"GTa5","advLabel":"GTkh"};